import { createContext } from 'react'

const CacheChecksumContext = createContext({})

export default CacheChecksumContext
